module.exports = __webpack_public_path__ + "static/media/jaime-maseda.edac4c4d.md";